export class OrderRejectDTO {
  reasonId: number;
  remark: string;
  purchaseId: number;
  rejectedBy: string;
  productImages:any [];
}
